import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-add-favorite-exchange',
    templateUrl: './add-favorite-exchange.component.html',
    styleUrls: ['./add-favorite-exchange.component.css']
})
export class AddFavoriteExchangeComponent implements OnInit {

    constructor() { }
    @Input() modalRef: BsModalRef;
    @Input() exchangeCodes: any;
    @Output() addToExchange = new EventEmitter();

    ngOnInit() {

    }

    selectedExchange = [];

    onSelect(event, id) {
        
        if (event.target.checked) {
            if (this.selectedExchange.find(x => x == id) == null) {
                this.selectedExchange.push(id);
            }
        }
        else {
            let index = this.selectedExchange.findIndex(x => x == id);
            if (index > -1) {
                this.selectedExchange.splice(index, 1);
            }
        }
    }

    onSubmit() {
        this.addToExchange.emit(this.selectedExchange);
    }

}
